<div class="flex align-items-center justify-content-between flex-wrap card"
    [class]="timezoneNotSet() && !isMtmacModel()?'bg-red-200':'bg-blue-200'">
    <div *ngIf="(clockPresent && !timezoneNotSet()) || datetimeData"
        class="flex align-items-center justify-content-start font-semibold border-round m-2">
        {{ ('DATETIME_DEVICE' | translate) + ': '+ getDateTime()}}
    </div>
    <div *ngIf="timezoneNotSet()" class="flex align-items-center justify-content-start font-semibold border-round m-2">
        {{ ('TIMEZONE_NOT_SET_WARNING_DEVICE' | translate)}}
    </div>
    <div *ngIf="!datetimeData"></div>
    <!-- <i class="signal-level {{ signalData.SignalLevel ? getSignalIcon(signalData.SignalLevel) : 'signal-off'}}"></i> TODO -->
    <div class="flex align-items-center border-round">
        <p-button label="{{ 'READ_DATETIME_DEVICE' | translate }}"
            [disabled]="!canGetDatetimeDevice() || readingDatetimeDevice" (click)="getDatetimeDevice()"
            [loading]="readingDatetimeDevice" [rounded]="false" [text]="true" severity="primary"
            styleClass="font-semibold" *ngIf="isMtmacModel()">
        </p-button>
        <p-button label="{{ 'WRITE_DATETIME_DEVICE' | translate }}" [disabled]="!canGetDatetimeDevice()"
            (click)="writeRtc()" [rounded]="false" [text]="true" severity="primary" styleClass="font-semibold"
            *ngIf="clockPresent && !timezoneNotSet() && !isMtmacModel()">
        </p-button>
        <p-button label="{{ 'EDIT_SITE' | translate }}" [disabled]="!canGetDatetimeDevice()" (click)="editSite()"
            [rounded]="false" [text]="true" severity="primary" styleClass="font-semibold "
            *ngIf="clockPresent && timezoneNotSet()">
        </p-button>
    </div>
</div>